<template>
    <div class="category_total">
        <div style="margin-bottom: 20px;">
            <!-- <el-button class="leader-common-button" @click="addNewData">新增</el-button> -->
            <el-form
                :label-position="'left'"
                :model="searchForm"
                ref="searchForm"
                class="leader-style-form"
                :inline="true"
            >
                <el-form-item
                    label="企业名称"
                    label-width="100px"
                    prop="cust_name"
                >
                    <el-input
                        placeholder="请输入企业名称"
                        type="text"
                        class="em_inpunt"
                        oninput="if(value.length>50)value=value.slice(0,50)"
                        clearable
                        v-model="searchForm.cust_name"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item
                    label="变压器名称"
                    label-width="90px"
                    prop="transformer_name"
                >
                    <el-input
                        placeholder="请输入变压器名称"
                        maxlength="20"
                        class="em_inpunt"
                        clearable
                        v-model="searchForm.transformer_name"
                    ></el-input>
                </el-form-item> -->

                <div style="float: right">
                    <el-button
                        size="medium"
                        type="warning"
                        @click="getCategotyTotal"
                        >检索</el-button
                    >
                    <el-button type="primary" @click="addNewData" size="medium"
                        >新增</el-button
                    >
                </div>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-scrollbar style="height: 90%">
                <el-table border :data="tableData" class="leader-style-table">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (pageNum - 1) * pageSize + scope.$index + 1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="企业名称"
                        prop="cust_name"
                    ></el-table-column>
                    <el-table-column
                        label="名称"
                        prop="type_name"
                    ></el-table-column>
                    <el-table-column label="排序" prop="seq"></el-table-column>

                    <el-table-column label="操作" align="center" width="210">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="handleEditInfo(scope.row, '修改')"
                                >修改</el-button
                            >
                            <el-button
                                type="text"
                                @click="hanleDelInfo(scope.row)"
                                >删除</el-button
                            >
                            <el-button
                                type="text"
                                @click="handleEditInfo(scope.row, '查看')"
                                >查看</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <el-dialog
            class="leader-dialog"
            :title="dialogTitle"
            width="50%"
            :visible.sync="dialogStatus"
            @close="closeDiaCb"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <el-form
                :model="formData"
                ref="formData"
                label-width="160px"
                :rules="formDataRule"
                class="leader-style-form"
            >
                <el-form-item label="公司名称" prop="elec_customer_id">
                    <el-select
                        style="width: 100%"
                        v-model="formData.elec_customer_id"
                        :disabled="dialogTitle === '查看'"
                        placeholder="请选择公司"
                    >
                        <el-option
                            v-for="item in companys"
                            :key="item.elec_customer_id"
                            :label="item.cust_name"
                            :value="item.elec_customer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称" prop="type_name">
                    <el-input
                        v-model="formData.type_name"
                        maxlength="60"
                        placeholder="请输入名称"
                        oninput="value = value.replace(/\s/g, '')"
                        :disabled="dialogTitle === '查看'"
                    ></el-input>
                </el-form-item>

                <el-form-item label="排序" prop="seq">
                    <el-input
                        v-model="formData.seq"
                        maxlength="10"
                        placeholder="请输入排序"
                        v-Int.float
                        :disabled="dialogTitle === '查看'"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                
                <el-button
                    class="leader-common-button"
                    @click="addCommit"
                    v-if="dialogTitle != '查看'"
                    >保 存</el-button
                >

                <el-button
                    @click="closeDiaCb()"
                    class="leader-common-button"
                >{{ dialogTitle === "查看" ? "关 闭" : "取 消" }}</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            searchForm: {
                // transformer_name: "",
                cust_name: ""
            },
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            dialogTitle: "新增",
            dialogStatus: false,
            formData: {
                elec_customer_id: "",
                type_name: "",
                seq: ""
            },
            formDataRule: {
                elec_customer_id: [
                    {
                        required: true,
                        message: "请选择企业",
                        trigger: 'blur'
                    }
                ],
                type_name: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "blur"
                    }
                ],
                seq: [
                    {
                        required: true,
                        message: "请输入排序",
                        trigger: "blur"
                    }
                ]
            },
            companys: [], //公司列表
            pointSelects: []
        };
    },
    created() {
        this.getCustomerList();

        this.getCategotyTotal();
    },
    methods: {
        // 获取变压器列表
        getCategotyTotal() {
            api.getCategotyTotal({
                ...this.searchForm,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    {
                        this.tableData = res.bus_json.items;
                        this.totalNum = res.bus_json.totalNum;
                    }
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getCategotyTotal();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getCategotyTotal();
        },
        addNewData() {
            this.dialogTitle = "新增";
            this.dialogStatus = true;
        },
        handleEditInfo(row, title) {
            this.dialogTitle = title;
            this.dialogStatus = true;
            this.$nextTick(() => { 
                this.formData = { ...row };
            })
        },
        // 获取公司列表
        getCustomerList() {
            api.getCustomerList().then(res => {
                if (res && res.error_code === "0") {
                    this.companys = res.bus_json;
                }
            });
        },
        addCommit() {
            this.$refs["formData"].validate(valid => {
                if (valid) {
                    api.saveOrUpdateCategotyTotal({ ...this.formData }).then(
                        res => {
                            if (res && res.error_code === "0") {
                                this.$message({
                                    type: "success",
                                    message: res.error_msg
                                });
                                this.closeDiaCb();
                                this.getCategotyTotal();
                            }
                        }
                    );
                }
            });
        },
        hanleDelInfo(row) {
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteCategotyTotal({
                    tree_unit_type_id: row.tree_unit_type_id
                }).then(res => {
                    if (res && res.error_code === "0") {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.totalNum -
                                (this.pageNum - 1) * this.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.pageNum =
                                this.pageNum == 1
                                    ? this.pageNum
                                    : this.pageNum - 1;
                        }
                        this.getCategotyTotal();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        closeDiaCb() {
            this.$nextTick(() => { 
                this.$refs["formData"].resetFields();
                this.$refs["formData"].clearValidate();
            })
            this.dialogStatus = false;
        }
    }
};
</script>
<style lang="scss">
.category_total {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;
}
</style>
